<template>

  <dialog id="axiosRes" ref="dialog">
    <div id="axiosBox">
      <h2>系统提示</h2>
      <p id="axiosContent" onclick="axiosRes.showModal()"></p>

      <!-- <button onclick="axiosRes.close()">我知道了</button> -->
      <Button @click="close()">我知道了</Button>

    </div>
  </dialog>
</template>
<script>
export default {
  data() {
    return {

    }
  },
  methods: {
    close() {
      this.$refs.dialog.close();
      this.$Spin.hide();
    }
  }
}
</script>
<style>
#axiosRes {
  padding: 0;
  border: 0;
  margin-top: 100px;
  box-shadow: 10px 10px 20px #999;
  background: none
}

#axiosBox {
  width: 340px;
  border-radius: 6px;
  background: #fff;
  padding: 15px;
  text-align: left;
  background: #fff;
  display: flex;
  flex-wrap: wrap;
}

#axiosBox h2 {
  width: 100%;
  margin-bottom: 6px;
  margin-top: 10px;
  font-size: 18px;
}

#axiosBox p {
  width: 100%;
  margin-bottom: 20px;
  font-size: 14px;
}

#axiosBox button {
  margin-left: auto;
  border: none;
  background: #4885e7;
  color: #fff;
  height: 30px;
  padding: 0 20px;
  border-radius: 4px;
  outline: none;
}

#axiosBox button:hover {
  opacity: 0.8;
}
</style>



// WEBPACK FOOTER //
// ../common/src/components/axiosRes.vue